export default __webpack_public_path__ + "ce69476259fbc6a43cb95a4f0e40ff9a.png";